export default "__VITE_ASSET__BxDSkPkm__"